import { render, staticRenderFns } from "./Shim.vue?vue&type=template&id=1201be94"
import script from "./Shim.vue?vue&type=script&lang=js"
export * from "./Shim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports